import ComingSoon from "../../other/ComingSoon";
import {usePageTitle} from "_hooks";
import {useRoutes} from "react-router-dom";
import {lazy} from "react";
import {LoadComponent} from "@loadComponent";

const List = lazy(() => import('./List'));

const Calendar = () => {
    usePageTitle({title: 'Minha agenda', breadCrumbItems: []});

    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={List}/>
        }
    ]);
};

export default Calendar;
